/* eslint-disable max-len */
import { organizationusersList } from "./apiSlice"

const reportsList = organizationusersList.injectEndpoints({
    tagTypes: ['reports','Alerts'],
    endpoints: (builder) => ({
        getDeviceReportList: builder.query({
            query: (searchParams) => ({
                url: `patients/list-device-alerts?${searchParams}`,
                method: 'GET',
               
            }),
        }),
        getProviderReportList: builder.query({
            query: (searchParams) => ({
                url: `patients/list-providers-alerts-report?${searchParams}`,
                method: 'GET',
               
            }),
        }),
        getAlertList: builder.query({
            query: (queryParamsPassed) => `patients/list-historical-readings?${queryParamsPassed?.searchparams}`,
            providesTags:(result=[],error,arg)=>error===undefined?[
                
                'Alerts',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({_id})=>({type:'Alerts', id:_id}))
            ]:[]
            
        }),
    }),
   
    overrideExisting: false
})


export const {
    useGetDeviceReportListQuery,
    useGetProviderReportListQuery,
    useGetAlertListQuery,

} = reportsList